import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import { FILTER_LABELS } from "../CandidateStaticConstants";
function DateRangeFilter({ onRetrieveDateRangeData, value }) {
  const [dateRangeFrom, setDateRangeFrom] = useState(null);
  const [dateRangeTo, setDateRangeTo] = useState(null);

  // useEffect(() => {
  //   if (dateRangeFrom && dateRangeTo) {
  //     const dateRangeData = {
  //       field: "job.updatedAt",
  //       value: dateRangeFrom || null,
  //       value2: dateRangeTo || null,
  //     };
  //     onRetrieveDateRangeData("Date Range", dateRangeData);
  //   }
  // }, [dateRangeFrom, dateRangeTo]);

  const handleDateRangeFrom = (e) => {
    const data = {
      value: e.target?.value || null,
      externalFilter: true,
      filterType: "custom",
    };
    onRetrieveDateRangeData(FILTER_LABELS.dateRange, data);
  };

  const handleDateRangeTo = (e) => {
    const data = {
      value2: e.target?.value || null,
      externalFilter: true,
      filterType: "custom",
    };
    onRetrieveDateRangeData(FILTER_LABELS.dateRange, data);
  };

  return (
    <div className="d-flex flex-row align-items-center gap-2">
      <div className="d-flex flex-row align-items-center gap-2">
        <span>From</span>
        <Input
          type="date"
          name="dateFrom"
          className="border-light w-100"
          onChange={(e) =>
            // onRetrieveDateRangeData(FILTER_LABELS.dateRange, e.target?.value)
            handleDateRangeFrom(e)
          }
          value={value?.value || ""}
        />
      </div>
      <div className="d-flex flex-row align-items-center gap-2">
        <span>To</span>
        <Input
          type="date"
          name="dateTo"
          className="border-light w-100"
          onChange={(e) =>
            // onRetrieveDateRangeData(
            //   FILTER_LABELS.dateRange,
            //   e.target?.value,
            //   "value2"
            // )
            handleDateRangeTo(e)
          }
          value={value?.value2 || ""}
        />
      </div>
    </div>
  );
}

export default DateRangeFilter;
